<template>
  <div class="pedersen-verify-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="原始数据" prop="value">
            <el-input v-model="formDate.value" placeholder="请输入非负整数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="数据承诺" prop="commitment">
            <el-input v-model="formDate.commitment" placeholder="请输入数据承诺"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="随机因子" prop="opening">
            <el-input v-model="formDate.opening" placeholder="请输入随机因子"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="验证结果" prop="result">
            <el-input v-model="formDate.result" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-button type="primary" @click="handlePedersenVerify()">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      formDate: {
        value: null,
        commitment: '',
        opening: '',
        result: ''
      },
      methodOption: [
        {
          label: 'ProveAfterAddNum',
          value: 'ProveAfterAddNum'
        },
        {
          label: 'ProveAfterAddCommitment',
          value: 'ProveAfterAddCommitment'
        },
        {
          label: 'ProveAfterSubNum',
          value: 'ProveAfterSubNum'
        },
        {
          label: 'ProveAfterSubCommitment',
          value: 'ProveAfterSubCommitment'
        },
        {
          label: 'ProveAfterMulNum',
          value: 'ProveAfterMulNum'
        }
      ],
      editRules: {
        value: [
          { required: true, message: '请输入原始数据', trigger: 'blur' },
          { pattern: /^\d+$/, message: '请输入非负整数', trigger: 'blur' }
        ],
        commitment: [{ required: true, message: '请输入数据承诺', trigger: 'blur' }],
        opening: [{ required: true, message: '请输入随机因子', trigger: 'blur' }]
      },
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  mounted() {},
  methods: {
    handlePedersenVerify() {
      this.$refs.formDate.validate().then(valid => {
        if (valid) {
          this.formDate.value = Number(this.formDate.value)
          this.$apis.bulletproofs.pedersenVerify(this.formDate).then(res => {
            if (res) {
              this.formDate.result = res.data.result
              if (res.data.result) {
                this.$message.success('成功!')
              } else {
                this.$message.error('失败!')
              }
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.pedersen-verify-wrapper {
  .el-row {
    margin: 0 calc(0px - var(--base-size-16));

    .el-col {
      padding: 0 var(--base-size-16);
    }
  }
}
</style>
